import { createExternalStore } from './createExternalStore';

/**
 * Client-only inbox message-composer state, migrated off Apollo `makeVar` reactive vars.
 * Read reactively via `useValue()`; written imperatively via `set()`.
 */

/**
 * Transports text for the AddMessage composer to append to its current input.
 * AddMessage consumes it and resets it to '' once applied.
 */
export const addMessageInputTextToAppendStore = createExternalStore('');

/**
 * Clears the AddMessage input and appends this text to it.
 * AddMessage consumes it and resets it to '' once applied.
 */
export const clearAndAppendMessageInputTextStore = createExternalStore('');

/** Whether the AddMessage input should take focus. */
export const isAddMessageInputFocusedStore = createExternalStore(false);

/** Whether the conversation search bar has focus (used to arbitrate focus with AddMessage). */
export const isConversationSearchBarFocusedStore = createExternalStore(false);
